
<!--<div class="alert alert-warning">
    <div>isOwnedProperty: {{isOwnedProperty}}</div>
    <div>isProspectProperty: {{isProspectProperty}}</div>
</div>-->

<div class="row">
        <div class="col-12" *ngIf="opportunity as o">
            <!--Large View-->
            <div class="loan-option-card-desktop d-none d-md-block">
                <div>
                    <span style="padding: 0px !important; margin-right: 5px;" *ngIf="o?.opportunityInfo?.isLocked"><fa-icon
                            icon="lock"></fa-icon></span><strong>{{o?.opportunityType?.name?.toUpperCase()}}</strong>
                </div>

                <div class="loan-row">

                    <div class="detail">
                        <p class="value"><strong>{{o?.opportunityInfo?.matchedRate | number : '1.3-3'}}%</strong></p>
                        <p class="loan-label">
                            Rate  <a class="infoPopup" (click)="openInfoPopupWithOpp('RateAndAPR', o)">
                                <fa-icon icon="info-circle"></fa-icon>
                            </a>
                        </p>
                    </div>

                    <div class="detail">
                        <p class="value"><strong>{{o?.opportunityInfo?.matchedApr | number : '1.3-3' | null}}%</strong></p>
                        <p class="loan-label">
                            APR  <a class="infoPopup" (click)="openInfoPopupWithOpp('RateAndAPR', o)">
                                <fa-icon icon="info-circle"></fa-icon>
                            </a>
                        </p>
                    </div>

                    <div class="detail">
                        <p class="value"><strong>${{o?.opportunityInfo?.marketPayment | number : '1.0-0' | null}}</strong></p>
                        <p class="loan-label">
                            <span *ngIf="isProspectProperty">Est. </span>
                            <span *ngIf="isOwnedProperty">New </span>
                            <span>Monthly Payment <a class="infoPopup"
                                (click)="openInfoPopup('MonthlyPaymentClarification');">
                                <fa-icon icon="info-circle"></fa-icon>
                            </a></span>
                        </p>
                    </div>

                    <div class="detail" *ngIf="o?.opportunityInfo?.marketMonthlyPaymentMi > 0">
                        <p class="value"><strong>${{o?.opportunityInfo?.marketMonthlyPaymentMi | number : '1.0-0' | null}}</strong></p>
                        <p class="loan-label">
                            <span>Monthly MI <a class="infoPopup"
                                (click)="openInfoPopup('MortgageInsurance');">
                                <fa-icon icon="info-circle"></fa-icon>
                            </a></span>
                        </p>
                    </div>


                    <!--Show points on first line for prospect-->
                    <div class="detail" *ngIf="!isOwnedProperty">
                        <p class="value"><strong>${{o?.opportunityInfo?.pointsCost | number : '1.0-0' | null}}</strong></p>
                        <p class="loan-label">
                            Points&nbsp;
                            <span *ngIf="o?.opportunityInfo?.pointsCost < 0">(Credit) </span>
                            <span *ngIf="o?.opportunityInfo?.pointsCost >= 0">(Cost) </span>
                            <a class="infoPopup" (click)="openInfoPopupWithOpp('Points', o)">
                                <fa-icon icon="info-circle"></fa-icon>
                            </a>
                        </p>
                    </div>

                    <!--Show savings for owned properties-->
                    <div class="detail" *ngIf="isOwnedProperty">
                        <p class="value"><strong>${{abs(o.opportunityInfo.paymentSavings) | number : '1.0-0' | null}}</strong></p>
                        <p class="loan-label">
                            Est. Monthly
                            <span *ngIf="o.opportunityInfo.paymentSavings >= 0"> Savings </span>
                            <span *ngIf="o.opportunityInfo.paymentSavings < 0"> Increase </span>
                            <a class="infoPopup" (click)="openSavingsInfoPopup(o)">
                                <fa-icon icon="info-circle"></fa-icon>
                            </a>
                        </p>
                    </div>

                    <div class="button no-padding">
                        <a (click)="o.isSelected = !o.isSelected" style="color: #9B9B9B">
                            <span *ngIf="!o.isSelected">Expand Details&nbsp;<fa-icon icon="chevron-circle-down"></fa-icon></span>
                            <span *ngIf="o.isSelected">Hide Details&nbsp;<fa-icon icon="chevron-circle-up"></fa-icon></span>
                        </a>
                    </div>

                </div>


                <mat-expansion-panel class="clear-formatting" [expanded]="o.isSelected">

                    <div class="loan-row">
                        <div class="detail">
                            <p class="value"><strong>${{o?.opportunityInfo?.loanAmount | number : '1.0-0' | null}}</strong></p>
                            <p class="loan-label">
                                <span *ngIf="isOwnedProperty">New </span>
                                <span>Loan Amount</span>
                            </p>
                        </div>

                        <div class="detail">
                            <p class="value"><strong>{{o.opportunityInfo.loanTermMonths | number : '1.0-0' | null}}</strong></p>
                            <p class="loan-label">Total Payments</p>
                        </div>

                        <!--Show points on 2nd line for owned properties-->
                        <div class="detail" *ngIf="isOwnedProperty">
                            <p class="value"><strong>${{o?.opportunityInfo?.pointsCost | number : '1.0-0' | null}}</strong></p>
                            <p class="loan-label">
                                Points&nbsp;
                                <span *ngIf="o?.opportunityInfo?.pointsCost < 0">(Credit) </span>
                                <span *ngIf="o?.opportunityInfo?.pointsCost >= 0">(Cost) </span>
                                <a class="infoPopup" (click)="openInfoPopupWithOpp('Points', o)">
                                    <fa-icon icon="info-circle"></fa-icon>
                                </a>
                            </p>
                        </div>

                        <div class="detail">
                            <p class="value"><strong>${{o?.opportunityInfo?.closingCost | number : '1.0-0' | null}}</strong></p>
                            <p class="loan-label">
                                <span>Est. Upfront Costs </span>
                                <span *ngIf="o?.opportunityInfo?.closingCost < 0">(Credit) </span>
                                <a class="infoPopup" (click)="openInfoPopupWithOpp('EstimatedCosts', o)">
                                    <fa-icon icon="info-circle"></fa-icon>
                                </a>
                            </p>
                        </div>

                        <div class="detail">
                            <a (click)="viewLoanDetails(scenario, o?.opportunityInfo)">+ View Loan Details</a>
                        </div>

                        <div class="detail apply-now">
                            <lgv-apply-now-btn [Opportunity]="opportunity" Mode="button"></lgv-apply-now-btn>
                        </div>

                        <div class="button-grp-left">
                            <button *ngIf="isLockButtonShown" class="btn btn-primary" [disabled]="isLockRequested || !lgvPricingSvc.isLockRequestAllowed()"
                                (click)="requestToLock(scenario, o)">
                                Request to Lock <fa-icon icon="lock"></fa-icon>
                            </button>
                            <div class="Vert-10"></div>
                            <button [ngClass]="isLockButtonShown ? 'btn btn-outline' : 'btn btn-primary'" *ngIf="!isArchived" (click)="contactAgent(o)">
                                Contact Agent <fa-icon icon="arrow-right"></fa-icon>
                            </button>
                        </div>


                    </div>
                </mat-expansion-panel>


            </div>


            <!--Mobile View-->
            <div class="loan-option-card-mobile d-block d-md-none">
                <mat-expansion-panel class="slim-body" [expanded]="o.isSelected">
                    <mat-expansion-panel-header>
                        <div class="mobile-header">
                            <div><strong>{{o?.opportunityType?.name?.toUpperCase()}}</strong></div>

                            <div class="loan-row">

                                <div class="detail">
                                    <p class="value"><strong>{{o?.opportunityInfo?.matchedRate | number : '1.3-3'}}%</strong></p>
                                    <p class="loan-label">
                                        Rate  <a class="infoPopup" (click)="openInfoPopupWithOpp('RateAndAPR', o); $event.stopPropagation()">
                                            <fa-icon icon="info-circle"></fa-icon>
                                        </a>
                                    </p>
                                </div>

                                <div class="detail">
                                    <p class="value">
                                        <strong>${{o?.opportunityInfo?.marketPayment | number : '1.0-0' | null}}</strong>
                                    </p>
                                    <p class="loan-label">
                                        <span *ngIf="isProspectProperty">Est. </span>
                                        <span *ngIf="isOwnedProperty">New </span>
                                        <span>Monthly Payment</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </mat-expansion-panel-header>
                    <ng-template matExpansionPanelContent>
                        <div class="mobile-content">

                            <div class="loan-row">

                                <div class="detail">
                                    <p class="value"><strong>{{o?.opportunityInfo?.matchedApr | number : '1.3-3' | null}}%</strong></p>
                                    <p class="loan-label">
                                        APR  <a class="infoPopup" (click)="openInfoPopupWithOpp('RateAndAPR', o)">
                                            <fa-icon icon="info-circle"></fa-icon>
                                        </a>
                                    </p>
                                </div>

                                <div class="detail">
                                    <p class="value"><strong>${{o?.opportunityInfo?.pointsCost | number : '1.0-0' | null}}</strong></p>
                                    <p class="loan-label">
                                        Points&nbsp;
                                        <span *ngIf="o?.opportunityInfo?.pointsCost < 0">(Credit) </span>
                                        <span *ngIf="o?.opportunityInfo?.pointsCost >= 0">(Cost) </span>
                                        <a class="infoPopup" (click)="openInfoPopupWithOpp('Points', o)">
                                            <fa-icon icon="info-circle"></fa-icon>
                                        </a>
                                    </p>
                                </div>

                            </div>

                            <div class="loan-row">

                                <div class="detail">
                                    <p class="value"><strong>${{o?.opportunityInfo?.loanAmount | number : '1.0-0' | null}}</strong></p>
                                    <p class="loan-label">Loan Amount</p>
                                </div>

                                <div class="detail">
                                    <p class="value"><strong>{{o.opportunityInfo.loanTermMonths | number : '1.0-0' | null}}</strong></p>
                                    <p class="loan-label">Total Payments</p>
                                </div>

                            </div>

                            <div class="loan-row">
                                <div class="detail" *ngIf="o?.opportunityInfo?.closingCost !== 0">
                                    <p class="value"><strong>${{o?.opportunityInfo?.closingCost | number : '1.0-0' | null}}</strong></p>
                                    <p class="loan-label">
                                        <span>Est. Upfront Costs </span>
                                        <span *ngIf="o?.opportunityInfo?.closingCost < 0">(Credit) </span>
                                        <a class="infoPopup" (click)="openInfoPopupWithOpp('EstimatedCosts', o)">
                                            <fa-icon icon="info-circle"></fa-icon>
                                        </a>
                                    </p>
                                </div>

                                <!--Show savings for owned properties-->
                                <div class="detail" *ngIf="isOwnedProperty">
                                    <p class="value"><strong>${{o.opportunityInfo.paymentSavings | number : '1.0-0' | null}}</strong></p>

                                    <p class="loan-label">
                                        Est. Monthly
                                        <span *ngIf="o.opportunityInfo.paymentSavings >= 0"> Savings </span>
                                        <span *ngIf="o.opportunityInfo.paymentSavings < 0"> Increase </span>
                                        <a class="infoPopup" (click)="openMonthlySavingsPopup(o)">
                                            <fa-icon icon="info-circle"></fa-icon>
                                        </a>
                                    </p>
                                </div>

                                <div class="detail" *ngIf="o?.opportunityInfo?.marketMonthlyPaymentMi > 0">
                                    <p class="value"><strong>${{o?.opportunityInfo?.marketMonthlyPaymentMi | number : '1.0-0' | null}}</strong></p>
                                    <p class="loan-label">
                                        Monthly MI  <a class="infoPopup" (click)="openInfoPopupWithOpp('MortgageInsurance', o)">
                                            <fa-icon icon="info-circle"></fa-icon>
                                        </a>
                                    </p>
                                </div>

                                <div class="button-mobile">
                                    <div class="detail">
                                        <a (click)="viewLoanDetails(scenario, o?.opportunityInfo)">+ View Loan Details</a>
                                    </div>
                                    <lgv-apply-now-btn [Opportunity]="opportunity" Mode="button"></lgv-apply-now-btn>
                                    <div class="button-grp-left">
                                        <button *ngIf="isLockButtonShown" class="btn btn-primary" [disabled]="isLockRequested"
                                            (click)="requestToLock(scenario, o)">
                                            Request to Lock <fa-icon icon="lock"></fa-icon>
                                        </button>
                                        <button [ngClass]="isLockButtonShown ? 'btn btn-outline' : 'btn btn-primary'" *ngIf="!isArchived" (click)="contactAgent(o)">
                                            Contact Agent <fa-icon icon="arrow-right"></fa-icon>
                                        </button>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </ng-template>
                </mat-expansion-panel>

            </div>

        </div>
</div>
